import { useCompetition } from "./Competition";
import { hooks, models } from "@vote4dance/judging-sdk";
var SessionState = hooks.sessions.SessionState;
var useSession = hooks.sessions.useSession;
var Stream = hooks.streams.Stream;
var FederationSource = models.federations.FederationSource;
var UserFederationSource = models.federations.UserFederationSource;
import { FederationPermissions } from "@vote4dance/judging-schema";
export function useFederationSettings(competition_id) {
    const [inputCompetition, event, competitions, loading] = useCompetition(competition_id);
    const usingAcrobaticLevels = (inputCompetition === null || inputCompetition === void 0 ? void 0 : inputCompetition.competition_federation) === 'DSF';
    const usingPointSummary = (inputCompetition === null || inputCompetition === void 0 ? void 0 : inputCompetition.competition_federation) === 'DSF';
    const shouldShowResultComments = (inputCompetition === null || inputCompetition === void 0 ? void 0 : inputCompetition.competition_federation) === 'DSF';
    return {
        usingAcrobaticLevels,
        usingPointSummary,
        shouldShowResultComments
    };
}
export function useFederation(federation_id, all) {
    const [federations, loading, error] = Stream(all ? FederationSource : UserFederationSource);
    const sessionState = useSession();
    const isSystemAdministrator = SessionState.isSystemAdministrator(sessionState);
    const federation = federations && federations.find(federation => federation.federation_id === federation_id);
    const canEdit = isSystemAdministrator || (federation ? [FederationPermissions.Administrator, FederationPermissions.Owner].includes(federation.federation_permissions) : false);
    return [
        federation,
        loading,
        error,
        canEdit
    ];
}
